export default "__VITE_ASSET__30749954__"